<template>
  <base-dialog width="500px" :visible.sync="visible" class="favorite-dialog">
    <template v-slot:header>提示</template>
    <div class="description">
      <div class="label">收藏成功！说说你的理由：</div>
      <el-input
        v-model="favoriteInfo.description"
        type="textarea"
        :rows="4"
        class="value"
      ></el-input>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">保存</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import { saveFavorite } from "@/api/user"
import { deepClone } from "@/utils/common"
export default {
  name: "favorite-dialog",
  components: { BaseDialog, BaseButton },
  props: {
    from: String
  },
  data() {
    return {
      visible: false,
      favoriteInfo: ""
    }
  },
  methods: {
    open(favorite) {
      this.visible = true
      this.favoriteInfo = deepClone(favorite)
    },
    submit() {
      saveFavorite(this.favoriteInfo).then(res => {
        this.visible = false
        this.$message.success(this.from === "sheetDetail" ? "添加收藏理由成功" : "编辑收藏理由成功")
        if (this.from === "todo") {
          this.$emit("refresh")
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.favorite-dialog {
  .description {
    .label {
      margin-bottom: 10px;
    }
    .value {
      ::v-deep {
        .el-textarea__inner {
          resize: unset;
        }
      }
    }
  }
}
</style>
